import { formatISO } from "date-fns";
import { clearFilterValues } from "./column-options/clearFilterValues";
import {
  BooleanFilter,
  Column,
  DateFilter,
  NumberFilter,
  TaxonomyFilter,
  TextFilter,
} from "./column-options/types";

export const clearFilter = (f: any) => {
  if (!f) return f;
  if (f.type === "boolean") {
    return {
      ...f,
      value:
        typeof f.unfilteredValue === "undefined" ? null : f.unfilteredValue,
    };
  }
  return {
    ...f,
    ...clearFilterValues[f.type],
  };
};

export const isFilteredTaxonomy = (f: TaxonomyFilter) => f.value.length > 0;
export const isFilteredDate = (f: DateFilter) => {
  if (f.operator === "isBetween") {
    return !!f.date1 && !!f.date2;
  }
  return !!f.date1;
};
export const isFilteredNumber = (f: NumberFilter) => {
  if (f.operator === "between") {
    return (
      f.number1 !== null &&
      f.number2 !== null &&
      f.number1 !== undefined &&
      f.number2 !== undefined &&
      f.number1 !== ("" as any) &&
      f.number2 !== ("" as any)
    );
  }
  return (
    f.number1 !== null && f.number1 !== undefined && f.number1 !== ("" as any)
  );
};
export const isFilteredText = (f: TextFilter) => f.value.length > 0;

const isFilteredByType = {
  number: isFilteredNumber,
  text: isFilteredText,
  date: isFilteredDate,
  taxonomy: isFilteredTaxonomy,
  boolean: (f: BooleanFilter) =>
    typeof f.unfilteredValue === "undefined"
      ? f.value !== null
      : f.value !== f.unfilteredValue,
};

export const isColumnFiltered = (f: any) => {
  if (!f) return false;
  return isFilteredByType[f.type](f);
};

export const createAzureFilterParam = (columns: Column) => {
  const columnFilterStrings = columns.reduce((f: string[], c: Column) => {
    if (c.filter) {
      if (c.filter.type === "taxonomy" && isColumnFiltered(c.filter)) {
        f.push(`search.in(${c.key}, '${c.filter.value.join(",")}')`);
      }
      //
      else if (c.filter.type === "boolean" && isColumnFiltered(c.filter)) {
        f.push(`${c.key} eq ${c.filter.value}`);
      }
      //
      else if (c.filter.type === "text" && isColumnFiltered(c.filter)) {
        f.push(`search.ismatch('${c.filter.value}', '${c.key}')`);
      }
      //
      else if (c.filter.type === "date" && isColumnFiltered(c.filter)) {
        if (c.filter.operator === "isAfter") {
          f.push(
            `${c.key} gt ${formatISO(new Date(c.filter.date1!), {
              representation: "date",
            })}`
          );
        }
        //
        else if (c.filter.operator === "isBefore") {
          f.push(
            `${c.key} lt ${formatISO(new Date(c.filter.date1!), {
              representation: "date",
            })}`
          );
        }
        //
        else if (c.filter.operator === "isExact") {
          f.push(
            `${c.key} eq ${formatISO(new Date(c.filter.date1!), {
              representation: "date",
            })}`
          );
        }
        //
        else if (c.filter.operator === "isBetween") {
          f.push(
            `${c.key} ge ${formatISO(new Date(c.filter.date1!), {
              representation: "date",
            })} and ${c.key} le ${formatISO(new Date(c.filter.date2!), {
              representation: "date",
            })}`
          );
        }
      } else if (c.filter.type === "number" && isColumnFiltered(c.filter)) {
        let operatorStringNumber1: any = c.filter.operator;
        let operatorStringNumber2: any = c.filter.operator;
        if (c.filter.operator === "gt" && c.filter.includeNumber1) {
          operatorStringNumber1 = "ge";
        }
        //
        else if (c.filter.operator === "lt" && c.filter.includeNumber1) {
          operatorStringNumber1 = "le";
        }
        //
        else if (c.filter.operator === "between") {
          if (c.filter.includeNumber1) {
            operatorStringNumber1 = "ge";
          }
          //
          else {
            operatorStringNumber1 = "gt";
          }
          if (c.filter.includeNumber2) {
            operatorStringNumber2 = "le";
          }
          //
          else {
            operatorStringNumber2 = "lt";
          }
        }

        if (c.filter.operator === "between") {
          f.push(
            `${c.key} ${operatorStringNumber1} ${c.filter.number1} and ${c.key} ${operatorStringNumber2} ${c.filter.number2}`
          );
        } else {
          f.push(`${c.key} ${operatorStringNumber1} ${c.filter.number1}`);
        }
      }
    }
    return f;
  }, []);

  return [...columnFilterStrings].filter((s) => !!s).join(" and ");
};
